import { useEffect, useState } from 'react';
import defaultImage from "../assets/default_team.png"

export function TeamMember(props: { image: string, title: string, description: string, moreLink?: string }) {
    const [imgSrc, setImageSrc] = useState<string | undefined>();

    useEffect(() => {
        const loadImages = async () => {
            try {
                // Dynamic import requires a static path
                const imageModule = await import(`../assets/team/${props.image}`);
                setImageSrc(imageModule.default); 
            } catch (err) {
                console.error("Error loading image:", err);
                setImageSrc(undefined); // Handle the error by setting imgSrc to undefined or a placeholder
            }
        };

        loadImages();
    }, [props.image]); // Run this effect whenever src changes

    return (
        <div className="teamStrip">
            <img 
                src={imgSrc ? imgSrc : defaultImage} 
                alt={`Image of ${props.title}`} 
                className="teamImage"
            />
            <div className="teamText">
                <h2>{props.title}</h2>
                <p>{props.description}</p>
                {props.moreLink ? <a href={props.moreLink} target='_blank'>Learn more about {props.title}</a> : null}
            </div>
        </div>
    );
}
